<div id="accessmethodCard" class="control-card-white">
  <div class="control-card-header">
    <ng-container i18n="@@accessMethodsEditor_title">Metodi d'accesso</ng-container>
    <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
  </div>

  <div class="control-card-content">
    <div class="table-container">
      <div class="scrollable-wrapper">
        <table class="simple-table">

          <thead>
            <th i18n="@@accessMethodsEditor_type" style="width: 35%;">Tipo</th>
            <th i18n="@@accessMethodsEditor_code" style="width: 50%;">Codice </th>
            <th style="width: 15%; display:inline-flex;">
              <p i18n="@@accessMethodsEditor_guide" id="guide-button" style="margin-right: 10px;" (click)="showGuide()">
                Guida</p>
              <fa-icon icon="question-circle" class="icon-clickable" (click)="showGuide()"></fa-icon>

            </th>
          </thead>

          <tbody [formGroup]="accessMethodsForm">

            <ng-container formArrayName="items">
              <tr style="width: 17%;">
                <td>
                  <p id="appName" i18n="@@accessMethodsEditor_app">App</p>
                  <!-- <input formControlName="App" type="App" id="appName" /> -->
                </td>

                <td style="width: 83%;">
                  <p id="appCode">{{appCode}}</p>
                </td>
                <td></td>
              </tr>
              <tr *ngFor="let itemForm of items.controls; index as i">

                <ng-container [formGroup]="itemForm">

                  <td style="width: 17%;">
                    <select formControlName="type">
                      <option *ngFor="let type of accessMethodTypes" [ngValue]="type">
                        {{ type.text }}
                      </option>
                    </select>
                  </td>

                  <td style="width: 78%;">
                    <div *ngIf="isPhoneType(i)">
                      <select formControlName="prefix" style="width: 60%;">
                        <option *ngFor="let prefix of prefixes" [value]="prefix.value">
                          {{prefix.text}}
                        </option>
                      </select>
                      <input formControlName="code" type="text" style="width: 40%;" />
                    </div>

                    <div *ngIf="!isPhoneType(i)">
                      <input formControlName="code" type="text" />
                    </div>
                  </td>

                  <td style="width: 5%;">
                    <div class="method-table-buttons">
                      <fa-icon icon="minus-circle" class="icon-clickable" (click)="deleteItem(i)">
                      </fa-icon>
                    </div>
                  </td>
                </ng-container>

              </tr>
            </ng-container>

            <tr>
              <td colspan="4">
                <div class="io-table-buttons">
                  <fa-icon icon="plus-circle" class="icon-clickable" (click)="addEmptyItem()">
                  </fa-icon>
                </div>
              </td>
            </tr>

          </tbody>
        </table>
      </div>

    </div>



  </div>

  <div class="control-card-buttons">

    <a (click)="saveAccessMethods()" class="button">
      <ng-container i18n="@@accessMethodsEditor_save">Conferma</ng-container>
      <span>
        <fa-icon icon="save"></fa-icon>
      </span>
    </a>
    <p class="text-small text-error-new" *ngIf="pincodeHasLettersError"
      i18n="@@accessMethodsEditor_pincodeHasLettersError">
      Il codice pin non può contenere lettere o caratteri speciali
    </p>
    <p class="text-small text-error-new" *ngIf="pincodeLengthError"
      i18n="@@accessMethodsEditor_pincodeLengthError">
      Il codice pin deve essere di 6 cifre
    </p>
    <p class="text-small text-error-new" *ngIf="duplicateError"
      i18n="@@accessMethodsEditor_duplicateError">
      Non possono esserci metodi duplicati
    </p>
    <p class="text-small text-error-new" *ngIf="emptyCodeError"
      i18n="@@accessMethodsEditor_emptyCodeError">
      É necessario compilare tutti i campi
    </p>
    <p class="text-small text-error-new" *ngIf="remoteCodeError"
      i18n="@@accessMethodsEditor_remoteCodeError">
      Codice radiocomando inserito non valido
    </p>
    <p class="text-small text-error-new" *ngIf="wrongPhoneNumberError"
      i18n="@@accessMethodsEditor_phoneNumberError">
      Numero di telefono non valido
    </p>
    <p class="text-small text-error-new" *ngIf="methodAlreadyUsedError"
      i18n="@@accessMethodsEditor_method_already_used">
      Il metodo con codice {{methodStr}} è già in uso da un altro utente
    </p>
    <p class="text-small text-error-new" *ngIf="tooManyRemotesError"
      i18n="@@accessMethodsEditor_too_many_remotes">
      Il numero massimo di radiocomandi associabili ad un utente é {{maxRemotes}}
    </p>
    <p class="text-small text-error-new" *ngIf="tooManyMethodsError"
      i18n="@@accessMethodsEditor_too_many_metods">
      Il numero massimo di metodi d'accesso associabili ad un utente é {{maxMethods}}
    </p>

  </div>

  <app-loading-screen #accessmethodloader [loading]="false"></app-loading-screen>
</div>